import styled from '@emotion/styled';
import { withStyles } from '@mui/styles';
import RootButton from 'components/Button/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const RunningContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
`;

export const HeaderContainer = styled(RunningContainer)`
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const FooterContainer = styled(RunningContainer)`
  justify-content: flex-end;
  margin-top: 12px;
`;

export const Button = withStyles({
  root: {
    width: '30%',
  },
})(RootButton);
